import React, { useEffect } from "react";

import loginStep1 from '../../Resources/Images/Tutoriales/Login/login-1.jpg';
import loginStep2 from '../../Resources/Images/Tutoriales/Login/login-2.jpg';
import StepTutorial from './index-step';

function getSteps() {
    return ['Paso 1', 'Paso 2'];
}

function getStepContent(stepIndex) {
    switch (stepIndex) {
        case 0:
            return <StepTutorial image={loginStep1} text={[
                <span key="p1">Ingresar a <a href='http://productores.lifeseguros.com.ar/'>http://productores.lifeseguros.com.ar/</a>,
                    escribir el CUIT y contraseña que generó en el registro al sistema </span>,
                <span key="p2">Presionar el botón <b>Ingresar</b></span>]} />;
        case 1:
            return <StepTutorial image={loginStep2} text={[
                "Si los datos ingresados son correctos, se redireccionará al portal web PAS",
                <span key="p3">En caso que no recuerde su contraseña, acceda a
                    <a href='http://productores.lifeseguros.com.ar/recover-password' > http://productores.lifeseguros.com.ar/recover-password </a>
                    para poder reestablecerla</span>]} />;
        default:
            return '¡Tutorial completado!';
    }
}

export function Login({ activeStep, setSteps }) {
    const steps = getSteps();

    useEffect(() => {
        setSteps(steps);
    }, [setSteps, steps]);

    return (
        <>
            <h2>Cómo iniciar sesión</h2>

            {/* Stepper reemplazado */}
            <div className="d-flex justify-content-center mb-4">
                {steps.map((label, index) => (
                    <div
                        key={label}
                        className={`text-center mx-2 px-3 py-2 rounded ${index === activeStep ? 'bg-primary text-white' : 'bg-light text-secondary'}`}
                        style={{ minWidth: 80 }}
                    >
                        <div className="fw-bold">{label}</div>
                        <div className="small">Paso {index + 1}</div>
                    </div>
                ))}
            </div>

            <div>
                {getStepContent(activeStep)}
            </div>
        </>
    );
}
